import breadcrumbs from './breadcrumbs';
import languageSwitcher from './language-switcher';
import nav from './nav';
import pages from './pages';
import routes from './routes';
import form from './form';
import search from './search';
import footer from './footer';
import popup from './popup';

export default {
  breadcrumbs,
  footer,
  form,
  languageSwitcher,
  nav,
  popup,
  pages,
  routes,
  search,
};



// WEBPACK FOOTER //
// ./src/config/locales/en/index.js